// src/components/common/CommonTooltip.js
import Tooltip from '@mui/material/Tooltip';
import { useI18n } from "../../i18n/I18nContext";

export default function CommonTooltip(props) {
  const { title, children } = props;
  const { t } = useI18n();

  return (
    <Tooltip
      disableInteractive
      enterDelay={500}
      enterNextDelay={500}
      arrow={true}
      placement="right"
      title={t(title)}  // ✔ apenas 1 title, traduzido
    >
      {children}
    </Tooltip>
  );
}